// Replay the trace through the reviewer, annotating the graph live.

import { resolvedDecisions, validateTrace } from "../core/validation";
import { state } from "../core/state";
import { $ } from "./dom";
import { renderMap } from "./map";
import { renderNode } from "./card";
import { renderAll } from "./render";
import { toast } from "./toast";

export async function runValidation(): Promise<void> {
  const decisions = resolvedDecisions();
  if (!decisions.length) { toast("make a decision or two first, then validate"); return; }
  const btn = $("#validateBtn") as HTMLButtonElement | null;
  if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent ?? ""; btn.textContent = "Reviewing…"; }
  toast(`replaying ${decisions.length} decision${decisions.length > 1 ? "s" : ""} through the reviewer…`);
  await validateTrace((node) => {
    renderMap();                                   // verdict dots land live
    if (node.id === state.currentId) renderNode(node);
  });
  if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || "Validate"; }
  renderAll();
  const flagged = decisions.filter((d) => d.verdict && d.verdict.verdict !== "sound");
  toast(flagged.length
    ? `${flagged.length} of ${decisions.length} decision${decisions.length > 1 ? "s" : ""} flagged — see the map & doc`
    : `all ${decisions.length} decisions hold up ✓`);
}
